module.exports = __webpack_public_path__ + "img/point_to.ee232539.svg";